import { z } from 'zod'

export const qrCodeNormalizeRuleSchema = z.enum([
  'normalizeLengthByDivide10000',
  'normalizeLengthByDivide1000',
  'normalizeLengthByDivide100',
  'normalizeLengthByDivide10',
  'normalizeLengthAsNumber',
  'normalizeQuantityAsNumber',
  'normalizeLengthByMultiply1000',
  'normalizeQuantityByDivide1000',
  'normalizeSizeAddPrefixD',
  'normalizeSizeToFullWidthKana',
  'normalizeSizeRemoveNejiPrefix',
  'normalizeBranchNumberWithHyphen',
  'normalizeDropAllZeroHeatNumber',
  'normalizeHeatNumberRemoveHyphen',
  'normalizeHeatNumberAddPrefixC',
])
export type QrCodeNormalizeRule = z.infer<typeof qrCodeNormalizeRuleSchema>

export const qrCodeNormalizeRuleLabels = {
  normalizeLengthByDivide10000: '長さを10000で割って正規化',
  normalizeLengthByDivide1000: '長さを1000で割って正規化',
  normalizeLengthByDivide100: '長さを100で割って正規化',
  normalizeLengthByDivide10: '長さを10で割って正規化',
  normalizeLengthAsNumber: '長さを数値として正規化',
  normalizeQuantityAsNumber: '数量を数値として正規化',
  normalizeLengthByMultiply1000: '長さを1000倍して正規化',
  normalizeQuantityByDivide1000: '数量を1000で割って正規化',
  normalizeSizeAddPrefixD: '寸法にDを追加',
  normalizeSizeToFullWidthKana: '寸法の半角カナを全角カナに変換',
  normalizeSizeRemoveNejiPrefix: '寸法のネジ節鉄筋接頭辞（ネジ/ﾈｼﾞ）を除去',
  normalizeBranchNumberWithHyphen: '枝番にハイフンを復元',
  normalizeDropAllZeroHeatNumber: '全桁ゼロの製鋼番号を値なしとして扱う',
  normalizeHeatNumberRemoveHyphen: '製鋼番号のハイフンを除去',
  normalizeHeatNumberAddPrefixC: '製鋼番号にCを追加',
}

export const qrCodeNormalizeRuleOptions = Object.entries(qrCodeNormalizeRuleLabels).map(([key, label]) => ({
  value: key,
  label,
}))
